import React, { Component } from "react"
import { withTranslation } from "react-i18next"
import { connect } from 'react-redux'

import styled from 'styled-components'
import GenericModal from '../../../components/GenericModal'
import {ApplicationVersion} from '../../../constants'

const Content = styled.div`
  padding: 15px 20px 20px 20px;

  > div {
    font-family: Lato-Regular;
    font-size: 14px;
    line-height: 22px;
    color: #2B2B2B;
    margin: 0px;
    margin-bottom: 0px;
  }
`

const Footer = styled.div`
  > button {
    height: 43px;
    width: 100%;
  }

`

class AboutDialog extends Component {
   
  render() {
    const { t, configuration } = this.props;
    return (
      <GenericModal
        title={t('Navigation.About')}
        visible={this.props.visible}
        onCloseDialog={this.props.onCloseDialog}
        width={380}
        className="about-modal"
      >
        <Content>
          <div>{t('AboutDialog.ApplicationVersion', {version: ApplicationVersion})}</div>
          <div>{t('AboutDialog.ApiVersion', {version: configuration.api_version})}</div>
          <div>{t('AboutDialog.BackendVersion', {version: configuration.backend_version})}</div>
        </Content>
        <Footer>
          <button className="secondary-button" onClick={this.props.onCloseDialog}>{t('AboutDialog.OkButton')}</button>
        </Footer>
      </GenericModal>
    )
  }
}

const mapState = state => ({
  configuration: state.configuration
})


export default connect(mapState, null)((withTranslation('translations')(AboutDialog)))
